<div id="main">
  <div class="header">
    <div class="title">Notas de Serviço</div>
    <div class="menuicon" (click)="upload()">
      <icon icon="assets/icons/upload.svg" width="30px" height="30px"></icon>
    </div>
  </div>

  <div class="container">
    <billboard title="Pesquisa por data de Upload" height="auto">
      <div table="column">
        <labelinput title="Mês" type="number" [(value)]="month"></labelinput>
        <labelinput title="Ano" type="number" [(value)]="year"></labelinput>
        <buttoncomponent
          text="Buscar"
          background="var(--color-primary)"
          (click)="init_data()"
        ></buttoncomponent>
        <buttoncomponent
          text="Relatório de Erros"
          background="var(--color-green)"
          (click)="errors_report()"
        ></buttoncomponent>
        <buttoncomponent
          text="Relatório de Erros (Não enviados)"
          background="var(--color-tertiary)"
          (click)="no_sended_report()"
        ></buttoncomponent>
        <buttoncomponent
          text="Baixar Arquivos Com Erros"
          background="var(--color-red)"
          (click)="downloadErrorFile()"
        ></buttoncomponent>
        <buttoncomponent
          text="Baixar Arquivos Não Enviados"
          background="var(--color-red)"
          (click)="downloadErrorFile(true)"
        ></buttoncomponent>
      </div>
      <div table="column" style="border: 1px solid; border-radius: 3px; margin-top: 4px">
        <div style="padding-left: 8px; padding-right: 12px; font-size: 12px">
          Filtros:
        </div>
        <div>
          <labelinput title="Data de inserção" type="datetime-local" widthlabel="180px" [(value)]="date" (valueChange)="resetPagination()"></labelinput>
        </div>
        <div>
          <labelinput title="Nome do arquivo" type="text" widthlabel="180px" [(value)]="searchFileName" (valueChange)="resetPagination()"></labelinput>
        </div>
        <tooglebutton [(position)]="justerrors" (positionChange)="resetPagination()"
          ><span>Apenas Erros?</span></tooglebutton
        >
        <tooglebutton [(position)]="justnomodel" (positionChange)="resetPagination()"
          ><span>Apenas Modelo Desconhecido?</span></tooglebutton
        >
        <tooglebutton [(position)]="justnotsended" (positionChange)="resetPagination()"
          ><span>Apenas Não enviados?</span></tooglebutton
        >
      </div>
      <div table="column" style="border: 1px solid; border-radius: 3px; margin-top: 4px">
        <div style="padding-left: 8px; padding-right: 12px; font-size: 12px">
          Chave:
        </div>
        <div>
          <labelinput title="Busca por Chave" type="text" widthlabel="200px" [(value)]="searchChave"></labelinput>
        </div>
        <buttoncomponent
          text="Buscar por Chave"
          background="var(--color-primary)"
          (click)="searchByChave()"
        ></buttoncomponent>
      </div>
    </billboard>
    <br />
    <tablecomponent
      *ngIf="!loading"
      #tableComponent
      [columnsConfig]="configTable"
      [values]="list"
      [headerConfig]="TableHeaderConfig"
      [title]="'Lista de Notas Cadastradas - ' + totalItemsWithoutFilters + ' itens'"
      height="calc(100vh - 350px)"
      (onRowClick)="getItem($event)"
    ></tablecomponent>
    
    <div *ngIf="!loading" style="margin-top: 12px; display: flex; justify-content: space-between; align-items: center; padding: 0 12px; gap: 12px;">
      <div style="font-size: 14px; color: var(--color-text);">
        Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ (currentPage - 1) * pageSize + list.length }} de {{ totalItems }} itens
      </div>
      
      <div style="display: flex; gap: 8px; align-items: center;">
        <buttoncomponent
          text="← Anterior"
          background="var(--color-primary)"
          [disabled]="!hasPreviousPage"
          (click)="previousPage()"
          style="min-width: 100px;"
        ></buttoncomponent>
        
        <div style="font-size: 14px; color: var(--color-text); white-space: nowrap;">
          Página {{ currentPage }} de {{ totalPages }}
        </div>
        
        <buttoncomponent
          text="Próxima →"
          background="var(--color-primary)"
          [disabled]="!hasMoreItems"
          (click)="nextPage()"
          style="min-width: 100px;"
        ></buttoncomponent>
      </div>
    </div>
  </div>
</div>
<spinner *ngIf="loading">Carregando...</spinner>
